export const roles = {
    ALL: 'all',

    NA: 'national-administrator',
    NMIB: 'national-manager-ib',
    NTSISD: 'national-manager-sisd',
    NTFI: 'national-manager-fi',
    NTF: 'national-manager-farm',
    NTNF: 'national-manager-nonfarm',
    NRV: 'national-report-viewer',

    SA: 'state-administrator',
    SMIB: 'state-manager-ib',
    STSISD: 'state-manager-sisd',
    STFI: 'state-manager-fi',
    STF: 'state-manager-farm',
    STNF: 'state-manager-nonfarm',
    SRV: 'state-report-viewer',

    DA: 'district-administrator',
    DMIB: 'district-manager-ib',
    DTSISD: 'district-manager-sisd',
    DTFI: 'district-manager-fi',
    DTF: 'district-manager-farm',
    DTNF: 'district-manager-nonfarm',
    DRV: 'district-report-viewer',

    BA: 'block-administrator',
    BMIB: 'block-manager-ib',
    BTSISD: 'block-manager-sisd',
    BTFI: 'block-manager-fi',
    BTF: 'block-manager-farm',
    BTNF: 'block-manager-nonfarm',
    BRV: 'block-report-viewer',

    // SUB ROLES
    CLF_BK: 'Institutional Building:CLF Bookkeeper',
    VO_BK: 'Institutional Building:VO Bookkeeper',
    SHG_BK: 'Institutional Building:SHG Bookkeeper',

    BCIB: 'block-cadre-ib',
};

export const CLF_MEETING_VIEW_ROLES = [
    roles.BMIB,
    roles.CLF_BK,
    roles.BA,
    roles.DA,
    roles.BTSISD,
    roles.STSISD,
    roles.SMIB,
    roles.NMIB,
    roles.DMIB,
    roles.SA,
    roles.DTSISD,
    roles.NA,
    roles.NTSISD,
];
